var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-portal-split', {
    scopedSlots: _vm._u([{
      key: "list",
      fn: function fn() {
        return [_c('affiliate-list-card', {
          attrs: {
            "loading": _vm.loadingAll
          },
          on: {
            "isLoadingDetail": _vm.setloadingSelected
          }
        })];
      },
      proxy: true
    }, {
      key: "content",
      fn: function fn() {
        return [_c('affiliate-detail-card', {
          attrs: {
            "loading": _vm.getloadingSelected,
            "selectedUser": _vm.selectedUser
          }
        })];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }